import PropTypes from 'prop-types';
import React from 'react';

export default class ReviewHeaderUserBlurb extends React.Component {
	static propTypes = {
		review: PropTypes.object,
	};

	renderOrganization = review => {
		return review.user.fullName !== review.organization.name
			? ` from ${review.organization.name}`
			: '';
	};

	renderLocation = organization => {
		return !organization.address || !organization.address.stateProvince ||
			organization.address.stateProvince == ''
			? ''
			: !organization.address.city || organization.address.city == ''
			? ''
			: ` in ${organization.address.city}, ${organization.address.stateProvince}`;
	};

	render() {
		const { review } = this.props;

		return (
			<div>
				<div
					style={{
						fontSize: '14px',
						fontWeight: 'bold',
					}}>
					<span>
						{review.user.fullName}
						{this.renderOrganization(review)}
						{this.renderLocation(review.organization)}
					</span>
				</div>
				<div>{review.user.classification}</div>
			</div>
		);
	}
}
